export default "__VITE_ASSET__vUSN09U7__"